<template>
  <footer class="fixed-bottom text-center d-flex justify-content-center">
    <div class="row col-12 p-0">
      <div class="col p-0">
        <a class="active" @click="setPage('Home')">
            <i class="fas fa-home"></i><span>Home</span>
        </a>
      </div>
      <div class="col p-0">
        <a @click="setPage('Messages')" :class="indicators && indicators.kudosCnt > 0 ? 'indicator' : ''">
            <i class="fas fa-comment-alt"></i><span>Kudos</span>
        </a>
      </div>
      <div class="col p-0">
        <a @click="setPage('Notifications')" :class="indicators && indicators.notificationCnt > 0 ? 'indicator' : ''">
          <i class="fas fa-bell"></i><span>Notifications</span>
        </a>
      </div>
      <div class="col p-0">
        <a @click="setPage('More')">
            <i class="fas fa-cog"></i><span>Settings</span>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";

export default {
  name: 'Footer',
  props: [
    'user',
    'footer'
  ],
  data() {
    return {
      indicators: null
    }
  },
  methods: {
    getIndicators() {
      let self = this;
      if (self.user) {
        axios.get("/api/user/" + self.$session.get('id') + "/notification-kudos-count")
          .then(response => {
            self.indicators = response.data[0];
          });
      }
    }
  },
  mounted() {
    let self = this;
    $('footer a').click(function(){
      $('footer a.active').removeClass('active');
      $(this).addClass('active');
    });
  },
  watch: {
    user: function(){
      let self = this;
      self.getIndicators();
      setInterval(function(){
        self.getIndicators();
      }, 20000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/partials/Footer.vue